export default {
    namespaced: true,
    state: {
        isShowResources: false,
        resourcesList:[]
    },
    mutations: {
        setResourcesList(state,data) {
            state.resourcesList = data
        },
        setShow(state,data){
            state.isShowResources = data
        }
    }
};